// Content-Security-Policy violation monitoring.
// Logs any blocked resource to the console so violations are visible during
// development, QA and in production error monitoring.

export function initCspReporter() {
  if (typeof document === "undefined") return;

  document.addEventListener("securitypolicyviolation", (event) => {
    const e = event as SecurityPolicyViolationEvent;
    console.warn(
      "[CSP] Geblokkeerd door Content-Security-Policy:",
      {
        directive: e.effectiveDirective || e.violatedDirective,
        blockedURI: e.blockedURI,
        sourceFile: e.sourceFile,
        line: e.lineNumber,
        disposition: e.disposition,
      },
    );
  });
}
